<template>
	<v-container tag="section" aria-label="Benefits Section">
		<v-row class="d-flex align-center">
			<v-col cols="12" md="6" class="d-flex justify-center align-center">
				<v-img
					src="https://fs.antrego.net/landing/sales.webp"
					class="image-style"
					alt="Illustration showing the Stock Management feature of Antrego"
					contain
					max-height="450"
				/>
			</v-col>

			<v-col
				cols="12"
				md="6"
				class="text-container text-center justify-center justify-md-start text-md-left"
				tag="section"
			>
				<v-card-subtitle
					:class="isMobile ? 'v-typography--title1' : 'v-typography--title2'"
					class="accent--text title-with-line pa-0 pl-1"
					tag="h2"
				>
					{{ $t(`$landing.$stockFeature.title`) }}
				</v-card-subtitle>

				<v-card-title
					:class="isMobile ? 'v-typography--title' : isTablet ? 'v-typography--title' : 'v-typography--title3'"
					class="pa-1 text-center justify-center text-md-left justify-md-start mt-2 mb-4 line-height"
					tag="h3"
				>
					<span> {{ $t(`$landing.$stockFeature.main_title`) }} </span>
				</v-card-title>

				<v-card-subtitle
					:class="isMobile ? 'v-typography--body1' : 'v-typography--paragraph'"
					class="pa-1 mb-0 text-center justify-center text-md-left justify-md-start"
					tag="p"
				>
					{{ $t(`$landing.$stockFeature.desc`) }}
				</v-card-subtitle>

				<v-list tag="ul" class="pl-0 bg_transparent">
					<v-list-item
						v-for="benefit in displayBenefits"
						:key="benefit.text"
						:class="isMobile ? 'v-typography--body1' : 'v-typography--paragraph'"
						class="pa-1 d-flex align-center no-min-height text-center justify-center text-md-left justify-md-start"
						tag="li"
					>
						<img
							src="@/assets/red_check.webp"
							class="check-img mr-2"
							alt="Check icon indicating a benefit"
							loading="lazy"
							height="17"
							width="17"
						/>
						{{ $t(benefit.text) }}
					</v-list-item>
				</v-list>
				<v-btn
					v-if="!useDetailBenefits"
					class="mt-4"
					x-large
					color="secondary"
					@click="goToStockFeature"
					aria-label="Explore stock management features"
				>
					<span :class="isTablet ? 'v-typography--paragraph' : ''">
						{{ $t("explore_stock_management") }}
					</span>
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	props: { isMobile: Boolean, isTablet: Boolean, useDetailBenefits: Boolean },
	data() {
		return {
			benefits: [
				{ icon: "icon-check", text: "$landing.$stockFeature.manage_stocks" },
				{ icon: "icon-check", text: "$landing.$stockFeature.speed_up_sales" },
				{ icon: "icon-check", text: "$landing.$stockFeature.access_potential_customers" },
				{ icon: "icon-check", text: "$landing.$stockFeature.global_market" },
			],
			detailBenefits: [
				{ icon: "icon-check", text: "$landing.$stockFeature.$detailPage.benefit_1" },
				{ icon: "icon-check", text: "$landing.$stockFeature.$detailPage.benefit_2" },
				{ icon: "icon-check", text: "$landing.$stockFeature.$detailPage.benefit_3" },
				{ icon: "icon-check", text: "$landing.$stockFeature.$detailPage.benefit_4" },
				{ icon: "icon-check", text: "$landing.$stockFeature.$detailPage.benefit_5" },
				{ icon: "icon-check", text: "$landing.$stockFeature.$detailPage.benefit_6" },
			],
		};
	},
	computed: {
		displayBenefits() {
			return this.useDetailBenefits ? this.detailBenefits : this.benefits;
		},
	},
	methods: {
		goToStockFeature() {
			this.$router.push({ name: "stock_feature" });
		},
	},
};
</script>

<style scoped>
.line-height {
	line-height: 30px !important;
}
.image-style {
	max-width: 100%;
	width: 100%;
}
.title-with-line {
	position: relative;
	display: inline-block;
}
.title-with-line::after {
	content: "";
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 2px;
	background-color: currentColor;
	transform: scaleX(0.4);
	transform-origin: left;
	margin-left: 4px;
}
.check-img {
	width: 17px;
	height: 17px;
}
.v-main {
	max-width: 100%;
	overflow-x: hidden;
}
@media (max-width: 960px) {
	.title-with-line::after {
		height: 0px;
	}
	.image-style {
		max-height: 300px;
	}
}
@media (max-width: 375px) {
	.image-style {
		max-height: 250px;
	}
	.check-img {
		width: 14px;
		height: 14px;
	}
	.pa-1 {
		padding: 0.5rem;
	}
	.mb-4 {
		margin-bottom: 1rem;
	}
}
</style>
